import { render, staticRenderFns } from "./CrawlerItem.vue?vue&type=template&id=37aded76&scoped=true"
import script from "./CrawlerItem.vue?vue&type=script&lang=js"
export * from "./CrawlerItem.vue?vue&type=script&lang=js"
import style0 from "./CrawlerItem.vue?vue&type=style&index=0&id=37aded76&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37aded76",
  null
  
)

export default component.exports